import { createAccountSubmissionPreviews } from "./AccountSubmissionPreviews";

export const AccountSubmissionPreviewsClosed = createAccountSubmissionPreviews(
	"account_submissions_closed",
	(account) =>
		!account.hasBeenActive && (account.status === "closed" || account.status === "declined"),
);
